var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPeopleBgray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vlg0f43w9a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.392157 0 0 0 0 0.435294 0 0 0 0 0.486275 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#vlg0f43w9a)",
    transform: "translate(-91.000000, -701.000000) translate(91.000000, 699.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M9.178 8.867c.61 0 1.164-.161 1.664-.484.5-.323.897-.754 1.192-1.293.294-.54.441-1.137.441-1.793 0-.646-.147-1.233-.441-1.762-.295-.528-.692-.95-1.192-1.265-.5-.316-1.054-.473-1.664-.473-.604 0-1.156.159-1.656.476-.5.318-.899.741-1.195 1.27-.297.529-.443 1.116-.438 1.762 0 .656.147 1.254.442 1.793.294.539.69.968 1.19 1.289.5.32 1.053.48 1.657.48zm0-1.531c-.307 0-.592-.09-.855-.27-.263-.18-.473-.423-.63-.73-.155-.307-.234-.654-.234-1.04 0-.364.079-.694.235-.991.156-.297.366-.533.629-.707.263-.175.548-.262.855-.262.318 0 .607.086.867.258.26.172.468.406.621.703.154.297.23.63.23 1 0 .38-.076.724-.23 1.031-.153.307-.36.552-.62.734-.261.183-.55.274-.868.274zm4.555 8.453c1.338 0 2.008-.469 2.008-1.406 0-.542-.158-1.09-.473-1.645-.315-.554-.764-1.066-1.348-1.535-.583-.469-1.276-.846-2.078-1.133-.802-.286-1.69-.43-2.664-.43-.974 0-1.862.144-2.664.43-.802.287-1.495.664-2.078 1.133-.583.469-1.033.98-1.348 1.535-.315.555-.472 1.103-.472 1.645 0 .937.669 1.406 2.007 1.406h9.11zm.062-1.539H4.561c-.073 0-.125-.014-.156-.043-.032-.029-.047-.069-.047-.121 0-.255.107-.547.32-.875.214-.328.528-.647.942-.957.414-.31.919-.568 1.515-.774.597-.205 1.278-.308 2.043-.308.766 0 1.447.103 2.043.308.596.206 1.102.464 1.516.774.414.31.728.629.941.957.214.328.32.62.32.875 0 .052-.014.092-.042.121-.03.029-.083.043-.16.043z",
    transform: "translate(-0.000000, 2.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeopleBgray);
export default __webpack_public_path__ + "static/media/ic_people_bgray.c52387f36cc32de18c66d64a3aaab516.svg";
export { ForwardRef as ReactComponent };